import React, { useMemo } from 'react';
import './DesignerLayout.less';
import classNames from 'classnames';
import { Overlay } from 'components/layer/Overlay';
import { getMaxZIndex } from 'utils/DomUtils';

export interface IDesignerLayoutProps extends React.ComponentPropsWithoutRef<'div'> {
  id: string;
  /**
   * Determines whether to show Designer in overlay or not
   *
   * @default true
   */
  showInLayer?: boolean;
  /**
   * Adds indent around designer.
   *
   * @default false
   */
  hasIndent?: boolean;
}

export function DesignerLayout({
  id,
  showInLayer = true,
  hasIndent = false,
  style,
  className,
  children,
  ...otherProps
}: IDesignerLayoutProps) {
  const zIndex = useMemo(() => getMaxZIndex(), []);

  const designer = (
    <div
      // onKeyUp event will not fire without "tabIndex", "-1" value guarantees that it will not allow focus via keyboard
      tabIndex={-1}
      className={classNames('dpc-designer', className, {
        'dpc-designer--indent': hasIndent,
      })}
      style={style}
      {...otherProps}
    >
      {children}
    </div>
  );

  if (showInLayer) {
    return (
      <Overlay id={id} className={classNames('dpc-designer-layer', 'ui-front')} zIndex={zIndex}>
        {designer}
      </Overlay>
    );
  } else {
    return designer;
  }
}
